import { NgTemplateOutlet } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'fdk-link',
  templateUrl: './link.component.html',
  styleUrl: './link.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet, RouterLink],
})
export class FdkLinkComponent {
  @Input() href = '';
  @Input() rel?: string;
  @Input() routerLink: RouterLink['routerLink'];
  @Input() target: '_self' | '_blank' | '_parent' | '_top' = '_self';
}
